import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ScheduleModule } from '@nestjs/schedule';
import { OtpDataService } from './services/otp.data-service';
import { OtpEntity } from './models/otp-entity';

@Module({
  imports: [TypeOrmModule.forFeature([OtpEntity]), ScheduleModule.forRoot()],
  providers: [OtpDataService],
  exports: [OtpDataService],
})
export class ServerDataAccessOtpModule {}
